import * as auth from "@script/auth";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoadingDots from "@components/LoadingDots";
import useStore from "../store/store";
import { toast } from "@components/toast/CustomToast";
import "@css/tokenLogin.css";

export default function TokenLogin() {
  const [isLoginError, setIsLoginError] = useState<boolean>(false);
  const [isUnauthorized, setIsUnauthorized] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const [memberIdValue, setMemberIdValue] = useState<string | null>(null);
  const [medToken, setMedToken] = useState<{
    token: string;
    memberid: string;
  } | null>(null);
  const { setLoginUser } = useStore();

  const navigate = useNavigate();

  const mworksTokenLogin = async (tokenObj: {
    token: string;
    memberid: string;
  }) => {
    try {
      const tokenLoginResult = await auth.tokenlogin(tokenObj);

      // tokenlogin에서 501 에러 체크
      if (!tokenLoginResult) {
        setIsLoginError(true);
        return;
      }

      // loadLoginUser에서 501 에러 체크
      const loginUser = await auth.loadLoginUser();

      if (!loginUser) {
        setIsLoginError(true);
        return;
      }

      setLoginUser(loginUser);
      navigate("/");
    } catch (error: unknown) {
      // 501 에러 처리 (권한 없음)
      if (
        error &&
        typeof error === "object" &&
        "status" in error &&
        error.status === 501
      ) {
        setIsUnauthorized(true);
        toast.error(
          "정보가 일치하지 않거나 서비스 이용자가 아닙니다. 관리자에게 문의해주세요."
        );
        // 501 에러 시 메디통으로 리다이렉트
        setTimeout(() => {
          window.location.replace("https://meditong.com");
        }, 2000);
        return;
      }

      // 기타 에러
      setIsLoginError(true);
    }
  };

  useEffect(() => {
    const memberId: string | null = searchParams.get("memberid");
    if (memberId) {
      setMemberIdValue(memberId);
    } else {
      setIsLoginError(true);
    }
  }, [searchParams]);

  useEffect(() => {
    if (memberIdValue !== null) {
      (async () => {
        const meditongToken = await auth.fetchTokenFromMeditong(memberIdValue);
        if (meditongToken) {
          setMedToken(meditongToken);
        } else {
          setIsLoginError(true);
        }
      })();
    }
  }, [memberIdValue]);

  useEffect(() => {
    if (medToken) {
      mworksTokenLogin({
        token: medToken.token,
        memberid: medToken.memberid,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [medToken]);

  useEffect(() => {
    if (isLoginError) {
      console.log("login error");
      setTimeout(() => {
        window.location.replace("https://meditong.com");
      }, 600);
    }
  }, [isLoginError]);

  return (
    <div className="tokenLogin_container">
      {isUnauthorized ? (
        <div className="tokenLogin_status">
          정보가 일치하지 않거나 서비스 이용자가 아닙니다. 관리자에게
          문의해주세요.
          <br />
          메디통 홈페이지로 이동합니다.
        </div>
      ) : isLoginError ? (
        <div className="tokenLogin_status">
          잘못된 로그인 정보입니다. 메디통 홈페이지로 이동합니다.
        </div>
      ) : (
        <div className="d-f fd-c ai-c jc-c">
          <div className="tokenLogin_status">
            로그인 정보를 불러오고 있습니다.
          </div>
          <LoadingDots size={30} gap={40} />
        </div>
      )}
    </div>
  );
}
